import { render, staticRenderFns } from "./DocumentRelatedDetails.vue?vue&type=template&id=64fb48d8&scoped=true&"
import script from "./DocumentRelatedDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentRelatedDetails.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRelatedDetails.vue?vue&type=style&index=0&id=64fb48d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb48d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fb48d8')) {
      api.createRecord('64fb48d8', component.options)
    } else {
      api.reload('64fb48d8', component.options)
    }
    module.hot.accept("./DocumentRelatedDetails.vue?vue&type=template&id=64fb48d8&scoped=true&", function () {
      api.rerender('64fb48d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/Invoices/NewDocumentRelated/DocumentRelatedDetails.vue"
export default component.exports